/**
 * Retrier function to play a first video element of a container until the video element is available
 * or a maximum number of attempts is reached.
 */
export default function tryToPlayFirstVideo(container: HTMLElement | null | undefined, maxAttempts = 3, delay = 1000) {
  let attempts = 0
  let tid: ReturnType<typeof setTimeout> | undefined = undefined

  const tryPlay = () => {
    const videoElement = container
      ?.querySelector('[data-recommendation-html-container]')
      ?.shadowRoot?.querySelector('video') as HTMLVideoElement | null
    if (videoElement) {
      // If the video element is not in viewport, we don't want to play it, so we check if it's visible
      const isVisible = videoElement.getBoundingClientRect().left >= 0

      if (!isVisible) {
        console.log('[tryToPlayFirstVideo] ~ Video element is not visible, skipping play')
        return
      }
      videoElement
        .play()
        .then(() => {
          clearTimeout(tid)
          console.log('[tryToPlayFirstVideo] ~ Video played successfully')
        })
        .catch(err => {
          console.error('[tryToPlayFirstVideo] ~ Video play error:', err)
          if (attempts < maxAttempts) {
            attempts++
            tid = setTimeout(tryPlay, delay)
          }
        })
    } else if (attempts < maxAttempts) {
      attempts++
      tid = setTimeout(tryPlay, delay)
    }
  }

  tryPlay()
}
